import { FocusEventHandler, ReactNode } from "react";

import CustomInput from "./CustomInput";

type TextInputProps = {
  value: string;
  placeholder?: string;
  pattern?: string;
  onChange: any;
  onClear?: any;
  type?: "text" | "email" | "password" | "number" | "tel";
  onBlur?: FocusEventHandler<HTMLElement>;
  label?: string;
  id?: string;
  name?: string;
  autoComplete?: "on" | "off" | "new-password";
  error?: string;
  isClearable?: boolean;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  button?: ReactNode;
  maxLength?: number;
  minLength?: number;
  spellCheck?: boolean;
};

const TextInput = ({
  value,
  placeholder,
  pattern,
  onChange,
  onClear,
  type,
  onBlur,
  label,
  id,
  name,
  autoComplete,
  error,
  required,
  disabled,
  className = "",
  button,
  maxLength,
  minLength,
  spellCheck = false,
}: TextInputProps) => {
  return (
    <CustomInput
      id={id}
      label={label}
      error={error}
      onClear={value && onClear}
      button={button}
    >
      <input
        type={type || "text"}
        value={value || ""}
        placeholder={placeholder || ""}
        pattern={pattern}
        id={id}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        autoComplete={autoComplete || "on"}
        required={required}
        disabled={disabled || false}
        className={className}
        maxLength={maxLength}
        minLength={minLength}
        spellCheck={spellCheck}
      />
    </CustomInput>
  );
};

export default TextInput;
